import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { useEffect, useMemo } from 'react';
import { EVENT, EVENT_SUBJECT } from '../../analytics/types';
/**
 * Subscribes to the events occuring in the card
 * plugin and fires analytics events accordingly
 */
export var DatasourceEventsBinding = function DatasourceEventsBinding(_ref) {
  var cardPluginEvents = _ref.cardPluginEvents;
  var eventHandlers = useMemo(function () {
    var _ref2;
    return _ref2 = {}, _defineProperty(_ref2, EVENT.CREATED, function (metadata) {
      // TODO Impl as part of https://product-fabric.atlassian.net/browse/EDM-7072
      // eslint-disable-next-line no-console
      console.log('CREATED', metadata.node, metadata.nodeContext);
    }), _defineProperty(_ref2, EVENT.UPDATED, function (metadata) {
      // TODO Impl as part of https://product-fabric.atlassian.net/browse/EDM-7072
      // eslint-disable-next-line no-console
      console.log('UPDATED', metadata.node, metadata.nodeContext);
    }), _defineProperty(_ref2, EVENT.DELETED, function (metadata) {
      // TODO Impl as part of https://product-fabric.atlassian.net/browse/EDM-7072
      // eslint-disable-next-line no-console
      console.log('DELETED', metadata.node, metadata.nodeContext);
    }), _ref2;
  }, []);

  /**
   * Subscribe to datasource events
   */
  useEffect(function () {
    var unsubscribe = cardPluginEvents.subscribe(function (_ref3) {
      var event = _ref3.event,
        subject = _ref3.subject,
        data = _ref3.data;
      if (subject === EVENT_SUBJECT.DATASOURCE) {
        eventHandlers[event](data);
      }
    });
    return function () {
      return unsubscribe();
    };
  }, [eventHandlers, cardPluginEvents]);
  return null;
};